import { Queries } from 'admin/lib/Api'
import PropTypes from 'prop-types'

export function LastModifiedBy({ modifier, modifiedById }) {
  if (modifier?.toLowerCase() === 'core') {
    return <LastModifiedByUser modifiedById={modifiedById} />
  }
  return <div>Last modified by: {modifier}</div>
}

function LastModifiedByUser({ modifiedById }) {
  const user = Queries.useUser(modifiedById)

  if (!user.isLoading && user.data) {
    return <div>Last modified by: {user.data.displayName}</div>
  } else {
    return null
  }
}

LastModifiedBy.propTypes = {
  modifier: PropTypes.string,
  modifiedById: PropTypes.string
}
